export default __webpack_public_path__ + "static/img/login_bg.b143a05.png";